<script>
import { mapActions, mapGetters } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'EmployeeListItem',
  mixins: [snackbarMixin],
  props: {
    employee: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth', 'isAdmin']),
  },
  methods: {
    ...mapActions('employeeList', ['transferToUser']),
    onDelete() {
      this.$emit('delete', this.employee);
    },
    transferEmployeeToUser() {
      this.transferToUser({ id: this.employee.id })
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage('Operation erfolgreich!');
            this.$emit('refreshList');
          }
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <v-icon v-if="employee.isSent">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td>
      <router-link :to="`/employee/show/${employee.id}`">{{ employee.username }}</router-link>
    </td>
    <td>{{ employee.email }}</td>
    <td>{{ employee.firstname }}</td>
    <td>{{ employee.surname }}</td>
    <td>
      <v-icon v-if="employee.enabled">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td>
      <v-icon v-if="employee.isDelete">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td>
      <v-layout row>
        <v-flex xs6>
          <v-tooltip v-if="isAdmin" bottom>
            <v-btn
              slot="activator"
              color="info"
              flat icon
              @click="transferEmployeeToUser"
            >
              <v-icon small>arrow_forward</v-icon>
            </v-btn>
            <span>in Benutzer transferieren</span>
          </v-tooltip>
        </v-flex>

        <v-flex xs6>
          <v-tooltip bottom>
            <v-btn
              v-if="auth.hasDeleteRights"
              :disabled="employee.isDelete"
              slot="activator"
              color="red darken-2"
              flat icon
              @click.native="onDelete"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Löschen</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </td>
  </tr>
</template>
